import React from "react";
import './Quote.scss';

const Quote = () => {
    return (
        <div className="quote d-flex align-items-center justify-content-center">
            <figure>
                <blockquote className="blockquote">
                    <p>Work hard to get what you like, otherwise you'll be forced to just like what you get.
                    <br />
                    A person who never made a mistake never tried anything new.</p>
                </blockquote>

                <figcaption className="blockquote-footer">
                    Albert Einstein
                </figcaption>
            </figure>
        </div>
    );
}

export default Quote;